module.exports = __webpack_public_path__ + "static/img/icon-arrow-circle.e1be322.png";